module.exports = __webpack_public_path__ + "fonts/feather.3d2fa2e5.woff";